/* eslint-disable max-depth */
/* exported SubscriptionManagerV3AAPI */

/* eslint-disable block-scoped-var */
/* eslint-disable no-prototype-builtins */


/*One Subscription Manager per application, for each componenet within application create a controller*/
// eslint-disable-next-line no-unused-vars

class SubscriptionManagerV3AAPI {
    static SubscriptionManagerV3AAPI = function (managerOptions) {

        function extend(obj1, obj2) {
            var result = {};
            for (var key in obj1) {
                if (obj1.hasOwnProperty(key)) {
                    result[key] = obj1[key];
                }
            }
            for (var key2 in obj2) {
                if (obj2.hasOwnProperty(key2)) {
                    result[key2] = obj2[key2];
                }
            }
            return result;
        }
        // data accessible to each Controller
        var markets = {},
            eventClassifiers = {},
            selections = {},
            matchedAmounts = {},
            prices = {},
            sportsbookPrices = {},
            selectionQueue = {},
            sportsPricesByMarketIndex = {},
            selectionsByMarketIndex = {},
            priceQueue = {},
            indexedMarketSelections = {};

        //Controller for eventCard, homepage, betslip etc.
        this.Controller = function (controllerOptions) {
            var currentMarketIdsForInformation = {},
                currentMarketIdsForInformationWithSelections = {},
                currentMarketIdsForInformationWithoutSelections = {},
                currentMarketIdsForPrices = {},
                currentMarketIdsForSportsbookPrices = {},
                currentMarketIdsForMatchedAmounts = {},
                currentSelectionIdsForPrices = {},
                currentSelectionIdsForSportsbookPrices = {},
                currentIndividualMarkets = {},
                gettingPrices = false;
            //used to know what this controller subscribed to so can unsubscribe

            var currentSubscriptionsIds = [];// used for unsubscribe all

            var marketDelegates = {},
                matchedAmountDelegates = {},
                selectionDelegates = {},
                priceDelegates = {},
                sportsbookPriceDelegates = {},
                eventDelegates = {},
                subscribedIds = {};

            var createUUID = function () {
                // Function found here: https://gist.github.com/jed/982883
                /*eslint no-bitwise:  ["error", { "allow": ["^", ">>"] }]*/
                var a = "";
                function b(c) {
                    // Need to create variables x and y to keep JSLint happy
                    var x = (c ^ (Math.random() * 16)) >> (c / 4);
                    var y = [1e7] + -1e3 + -4e3 + -8e3 + -1e11;
                    return c
                        ? (x).toString(16)
                        : (y).replace(/[018]/g, b);
                }
                return b(a);
            };
            //setup the initial load handler for each object type and then on first load attached the change delegate handler
            //Events
            if (controllerOptions.onEventChange !== undefined) {
                managerOptions.gecController.addSubscribedExchangeEventILDelegate(function startEvent(eventClassifier) {

                    var id = eventClassifier.addDelegate(function (changedEventClassifier, changes) {
                        controllerOptions.onEventChange({ newObject: changedEventClassifier, changes: changes });

                    });
                    eventDelegates[eventClassifier.eventClassifierId] = id;

                    eventClassifiers[eventClassifier.eventClassifierId] = eventClassifiers[eventClassifier.eventClassifierId] || eventClassifier;
                    controllerOptions.onEventChange({ newObject: eventClassifier });

                });
            }
            //Markets
            if (controllerOptions.onMarketChange !== undefined) {
                managerOptions.gecController.addSubscribedExchangeMarketILDelegate(function startMarket(market) {
                    //if listening for this market then add delegate
                    managerOptions.markets[market.marketId] = managerOptions.markets[market.marketId] || market;
                    //do not want to loose selections array on market from IAPI
                    managerOptions.markets[market.marketId] = extend(managerOptions.markets[market.marketId], market);

                    //if (currentMarketIdsForInformation[market.marketId]) {

                    var id = market.addDelegate(function (changedMarket, changes) {
                        //console.warn("market change:" + market.marketId);
                        controllerOptions.onMarketChange({ newObject: changedMarket, changes: changes });

                    });
                    marketDelegates[market.marketId] = id;
                    controllerOptions.onMarketChange({ newObject: market });

                    //check the selectionQueue to see if selections arrived before the market
                    for (var selectionId in selectionQueue) {
                        if (selectionQueue.hasOwnProperty(selectionId)) {
                            var selection = selectionQueue[selectionId];
                            // eslint-disable-next-line eqeqeq
                            if (selection.marketId == market.marketId) { //comparing number with string
                                controllerOptions.onSelectionChange({ newObject: selectionQueue[selectionId] });
                                delete selectionQueue[selectionId];
                            }
                        }
                    }

                    markets[market.marketId] = markets[market.marketId] || market;

                });
            }
            //MatchedAmounts
            if (controllerOptions.onMatchedAmountChange !== undefined) {
                managerOptions.gecController.addSubscribedExchangeMarketMatchedAmountILDelegate(function startMatchedAmount(matchedAmount) {
                    //if listening for this market then add delegate
                    if (currentMarketIdsForMatchedAmounts[matchedAmount.marketId]) {

                        var id = matchedAmount.addDelegate(function (changedMatchedAmount, changes) {
                            controllerOptions.onMatchedAmountChange({ newObject: changedMatchedAmount, changes: changes });

                        });
                        matchedAmountDelegates[matchedAmount.marketId] = id;
                    }
                    matchedAmounts[matchedAmount.marketId] = matchedAmounts[matchedAmount.marketId] || matchedAmount;
                });
            }
            //Selections
            if (controllerOptions.onSelectionChange !== undefined) {
                managerOptions.gecController.addSubscribedExchangeSelectionILDelegate(function startSelection(selection) {

                    var id = selection.addDelegate(function (changedSelection, changes) {

                        if (currentMarketIdsForInformation[changedSelection.marketId]) {
                            controllerOptions.onSelectionChange({ newObject: changedSelection, changes: changes });
                        }

                    });
                    selections[selection.selectionId] = selections[selection.selectionId] || selection;
                    selectionsByMarketIndex[selection.marketId] = selectionsByMarketIndex[selection.marketId] || {};
                    selectionsByMarketIndex[selection.marketId][selection.selectionId] = selections[selection.selectionId];
                    indexSelection(selection);

                    selectionDelegates[selection.selectionId] = id;
                    //console.warn("selection load for marekt:" + selection.marketId);

                    if (markets[selection.marketId] === undefined) {
                        //console.warn("Queue used for market:" + selection.marketId);
                        selectionQueue[selection.selectionId] = selection;
                    } else { //if (currentMarketIdsForInformation[selection.marketId])
                        controllerOptions.onSelectionChange({ newObject: selection });
                    }

                    managerOptions.selections[selection.selectionId] = selection;
                    selections[selection.selectionId] = selections[selection.selectionId] || selection;

                });
            }
            //Prices
            if (controllerOptions.onPriceChange !== undefined) {
                managerOptions.gecController.addSubscribedExchangeSelectionPricesILDelegate(function startPrice(price) {


                    prices[price.selectionId] = price;

                    if (selections[price.selectionId] !== undefined) {
                        selections[price.selectionId].backPrices = price.backPrices;
                        selections[price.selectionId].layPrices = price.layPrices;
                    }

                    if (currentMarketIdsForPrices[price.marketId] || currentIndividualMarkets[price.marketId] || currentSelectionIdsForPrices[price.selectionId]) {
                        currentSelectionIdsForPrices[price.selectionId] = true;

                        var id = price.addDelegate(function (changedPrice, changes) {
                            prices[changedPrice.selectionId] = changedPrice;
                            if (selections[changedPrice.selectionId] !== undefined) {
                                selections[changedPrice.selectionId].backPrices = changedPrice.backPrices;
                                selections[changedPrice.selectionId].layPrices = changedPrice.layPrices;
                            }
                            controllerOptions.onPriceChange({ newObject: changedPrice, changes: changes });

                        });
                        priceDelegates[price.selectionId] = id;


                        if (selections[price.selectionId] === undefined) {
                            //console.warn("Queue used for selection:" + price.selectionId);
                            priceQueue[price.selectionId] = price;
                            try {
                                controllerOptions.onPriceChange({ newObject: price });
                            } catch (ex) {
                                console.error("price before selection");
                            }
                        } else {
                            controllerOptions.onPriceChange({ newObject: price });
                        }


                    }

                });
            }

            if (controllerOptions.onSportsbookPriceChange !== undefined) {
                managerOptions.gecController.addSubscribedExchangeSelectionFixedOddsPricesILDelegate(function startSummaryPrice(summaryPrice) {

                    sportsbookPrices[summaryPrice.selectionId] = sportsbookPrices[summaryPrice.selectionId] || summaryPrice;
                    sportsbookPrices[summaryPrice.selectionId].backReferencePrice = summaryPrice.backReferencePrice;

                    sportsPricesByMarketIndex[summaryPrice.marketId] = sportsPricesByMarketIndex[summaryPrice.marketId] || {};
                    sportsPricesByMarketIndex[summaryPrice.marketId][summaryPrice.selectionId] = sportsbookPrices[summaryPrice.selectionId];

                    var id = summaryPrice.addDelegate(function (changedSummaryPrice, changes) {

                        if (currentMarketIdsForSportsbookPrices[changedSummaryPrice.marketId] || currentSelectionIdsForSportsbookPrices[changedSummaryPrice.selectionId]) {
                            currentSelectionIdsForSportsbookPrices[changedSummaryPrice.selectionId] = true;
                            sportsbookPrices[changedSummaryPrice.selectionId] = sportsbookPrices[changedSummaryPrice.selectionId] || changedSummaryPrice;
                            if (sportsbookPrices[changedSummaryPrice.selectionId] !== undefined) {
                                sportsbookPrices[changedSummaryPrice.selectionId].backReferencePrice = changedSummaryPrice.backReferencePrice;
                                sportsbookPrices[changedSummaryPrice.selectionId].layReferencePrice = changedSummaryPrice.layReferencePrice;
                            }
                            controllerOptions.onSportsbookPriceChange({
                                newObject: changedSummaryPrice, changes: changes
                            });
                        }
                    });
                    sportsbookPriceDelegates[summaryPrice.selectionId] = id;

                    if (currentMarketIdsForSportsbookPrices[summaryPrice.marketId] || currentSelectionIdsForSportsbookPrices[summaryPrice.selectionId]) {
                        if (selections[summaryPrice.selectionId] === undefined) {
                            //console.warn("Queue used for selection:" + price.selectionId);
                            priceQueue[summaryPrice.selectionId] = summaryPrice;
                            try {
                                controllerOptions.onSportsbookPriceChange({ newObject: summaryPrice });
                            } catch (ex) {
                                console.error("FO price before selection");
                            }
                        } else {
                            controllerOptions.onSportsbookPriceChange({
                                newObject: summaryPrice
                            });
                        }
                    }

                });
            }

            var subscribeToMarketInformation = function (params) {

                params.marketIdsForInformation?.forEach(function (marketId) {
                    currentMarketIdsForInformation[marketId] = currentMarketIdsForInformation[marketId] || true;

                    if (params.wantSelectionInformation) {
                        currentMarketIdsForInformationWithSelections[marketId] = currentMarketIdsForInformationWithSelections[marketId] || true;
                    } else {
                        currentMarketIdsForInformationWithoutSelections[marketId] = currentMarketIdsForInformationWithoutSelections[marketId] || true;
                    }
                });

                params.marketIdsForInformation?.forEach(function (marketId) {
                    if (selectionsByMarketIndex[marketId] !== undefined) {

                        Object.keys(selectionsByMarketIndex[marketId]).forEach(function (selectionId) {
                            if (controllerOptions.onSelectionChange !== undefined) {
                                controllerOptions.onSelectionChange({
                                    newObject: selectionsByMarketIndex[marketId][selectionId], changes: undefined
                                });
                            }
                        });
                    }
                });


                managerOptions.gecController.subscribeMarketInformation({
                    marketIds: params.marketIdsForInformation,
                    eventClassifierId: params.eventClassifierId, //eventId,
                    fetchOnly: false,
                    wantExchangeLangugeInformationOnly: true,
                    wantSelectionInformation: (params.wantSelectionInformation === true),
                    wantSelectionBlurb: (params.wantSelectionBlurb !== false),
                    marketTaggedValueTopicNames: "XSP~XSPA",
                    callbackOnSuccess: function (response) {
                        var i;
                        if (response.subscriptionId === undefined || isNaN(response.subscriptionId)) {
                            console.error("subscribeMarketInformation subscription Id was null");
                        } else {
                            subscribedIds[params.uuid] = subscribedIds[params.uuid] || [];
                            subscribedIds[params.uuid].push(response.subscriptionId);
                            currentSubscriptionsIds.push(response.subscriptionId);

                            ////handle inactive markets
                            if (response.marketIds !== undefined) {

                                for (i = 0; i < response.marketIds.length; i = i + 1) {
                                    var thisMarketId = response.marketIds[i];
                                    delete currentMarketIdsForInformation[thisMarketId];
                                    delete currentMarketIdsForInformationWithSelections[thisMarketId];
                                    delete currentMarketIdsForInformationWithoutSelections[thisMarketId];

                                    if (controllerOptions.onMarketChange !== undefined) {
                                        controllerOptions.onMarketChange({ newObject: { marketId: thisMarketId, marketStatus: 4, marketStatusId: 4, status: 0 } });
                                    }
                                }
                            }

                            if (params.marketIdsForInformation !== undefined) {
                                for (i = 0; i < params.marketIdsForInformation.length; i = i + 1) {
                                    currentMarketIdsForInformation[params.marketIdsForInformation[i]] = response.subscriptionId;
                                }
                            }

                            //loop through market we want to listen for and if we dont have a delegate add one
                            //we may not have a delegate if other component already subscribed
                            for (var marketId in currentMarketIdsForInformation) {
                                if (currentMarketIdsForInformation.hasOwnProperty(marketId)) {
                                    if (marketDelegates[marketId] === undefined) {
                                        markets[marketId] = markets[marketId] || managerOptions.gecController.getCachedSubscribedExchangeMarket(marketId);
                                        if (markets[marketId] === undefined) {
                                            delete markets[marketId];
                                            return;
                                        }
                                        var id = markets[marketId].addDelegate(function (market, changes) {
                                            controllerOptions.onMarketChange({ newObject: market, changes: changes });
                                        });

                                        marketDelegates[marketId] = id;
                                    }
                                    controllerOptions.onMarketChange({ newObject: markets[marketId] });
                                }
                            }

                        }
                        params.callbackOnSuccess(response);

                    },
                    callbackOnException: function (resp) {
                        console.error("SubscribeMarketInformation Exception:" + resp.name + resp.returnCode);
                        if (params.callbackOnException) {
                            params.callbackOnException(resp);
                        }
                    }
                });
            };

            var subscribeToMarketPrices = function (params) {
                params.marketIdsForPrices?.forEach(function (marketId) {

                    currentMarketIdsForPrices[marketId] = currentMarketIdsForPrices[marketId] || true;
                });
                gettingPrices = true;
                //console.log("sm:subscribeToMarketPrices-gettingPrices" + gettingPrices);

                managerOptions.gecController.subscribeDetailedMarketPrices({
                    numberBackPrices: params.numberForSidePrices || 3,
                    numberLayPrices: params.numberAgainstSidePrices || 3,
                    filterByVolume: managerOptions.preferences.marketByVolumeAmount || 1,
                    marketIds: params.marketIdsForPrices,
                    eventClassifierId: null,
                    fetchOnly: false,
                    callbackOnSuccess: function (response) {
                        gettingPrices = false;
                        //console.log("sm:subscribeToMarketPrices-gettingPrices" + gettingPrices);
                        var i;
                        if (response.subscriptionId === undefined || isNaN(response.subscriptionId)) {
                            console.error("subscribeDetailedMarketPrices subscription Id was null");
                        } else {
                            subscribedIds[params.uuid] = subscribedIds[params.uuid] || [];
                            subscribedIds[params.uuid].push(response.subscriptionId);
                            currentSubscriptionsIds.push(response.subscriptionId);

                            ////handle inactive markets
                            if (response.marketIds !== undefined) {

                                for (i = 0; i < response.marketIds.length; i = i + 1) {
                                    var thisMarketId = response.marketIds[i];
                                    delete currentMarketIdsForInformation[thisMarketId];
                                    delete currentMarketIdsForInformationWithSelections[thisMarketId];
                                    delete currentMarketIdsForInformationWithoutSelections[thisMarketId];

                                    if (controllerOptions.onMarketChange !== undefined) {
                                        var market = extend({ marketId: thisMarketId, marketStatus: 4, marketStatusId: 4, status: 0 }, markets[thisMarketId]);
                                        controllerOptions.onMarketChange({ newObject: market });
                                    }
                                }
                            }

                            for (i = 0; i < params.marketIdsForPrices.length; i = i + 1) {
                                currentMarketIdsForPrices[params.marketIdsForPrices[i]] = response.subscriptionId;
                            }

                            //loop through market we want to listen for and if we dont have a delegate add one
                            //we may not have a delegate if other component already subscribed
                            for (var selectionId in currentSelectionIdsForPrices) {
                                if (currentSelectionIdsForPrices.hasOwnProperty(selectionId)) {
                                    if (priceDelegates[selectionId] === undefined) {
                                        //prices[marketId] = markets[marketId] || managerOptions.gecController.getMarket(marketId);

                                        if (prices[selectionId] !== undefined) {
                                            var id = prices[selectionId].addDelegate(function (price, changes) {
                                                controllerOptions.onPriceChange({ newObject: price, changes: changes });

                                            });

                                            priceDelegates[selectionId] = id;

                                        }

                                    }
                                    controllerOptions.onPriceChange({ newObject: prices[selectionId] });
                                }
                            }
                        }
                        params.callbackOnSuccess(response);
                    },
                    callbackOnException: function (resp) {
                        gettingPrices = false;
                        console.error("SubscribeDetailedMarketPrices Exception:" + resp.name + resp.returnCode);
                        if (params.callbackOnException) {
                            params.callbackOnException(resp);
                        }
                    }
                });
            };

            var subscribeToMarketSportsbookPrices = function (params) {
                params.marketIdsForSportsbookPrices?.forEach(function (marketId) {

                    currentMarketIdsForSportsbookPrices[marketId] = currentMarketIdsForSportsbookPrices[marketId] || true;
                });

                params.marketIdsForSportsbookPrices.forEach(function (marketId) {
                    if (sportsPricesByMarketIndex[marketId] !== undefined) {

                        Object.keys(sportsPricesByMarketIndex[marketId]).forEach(function (selectionId) {
                            controllerOptions.onSportsbookPriceChange({
                                newObject: sportsPricesByMarketIndex[marketId][selectionId], changes: undefined
                            });

                        });
                    }
                });

                managerOptions.gecController.subscribeFixedOddsMarketPrices({
                    marketIds: params.marketIdsForSportsbookPrices,
                    eventClassifierId: undefined,
                    fetchOnly: false,
                    callbackOnSuccess: function (response) {

                        var i;
                        if (response.subscriptionId === undefined || isNaN(response.subscriptionId)) {
                            console.error("subscribeFixedOddsMarketPrices subscription Id was null");
                        } else {
                            subscribedIds[params.uuid] = subscribedIds[params.uuid] || [];
                            subscribedIds[params.uuid].push(response.subscriptionId);
                            currentSubscriptionsIds.push(response.subscriptionId);

                            for (i = 0; i < params.marketIdsForSportsbookPrices.length; i = i + 1) {
                                currentMarketIdsForSportsbookPrices[params.marketIdsForSportsbookPrices[i]] = response.subscriptionId;
                            }
                        }
                        params.callbackOnSuccess(response);
                    },
                    callbackOnException: function (resp) {
                        console.error("subscribeFixedOddsMarketPrices Exception:" + resp.name + resp.returnCode);
                        if (params.callbackOnException) {
                            params.callbackOnException(resp);
                        }
                    }
                });
            };


            var subscribeToMarketMatchedAmount = function (params) {

                params.marketIdsForMatchedAmounts?.forEach(function (marketId) {
                    currentMarketIdsForMatchedAmounts[marketId] = currentMarketIdsForMatchedAmounts[marketId] || true;
                });

                managerOptions.gecController.subscribeMarketMatchedAmounts({
                    marketIds: params.marketIdsForMatchedAmounts,
                    eventClassifierId: null,
                    fetchOnly: false,
                    callbackOnSuccess: function (response) {
                        if (response.subscriptionId === undefined || isNaN(response.subscriptionId)) {
                            console.error("subscribeMarketMatchedAmounts subscription Id was null");
                        } else {
                            subscribedIds[params.uuid] = subscribedIds[params.uuid] || [];
                            subscribedIds[params.uuid].push(response.subscriptionId);
                            currentSubscriptionsIds.push(response.subscriptionId);

                            params.marketIdsForMatchedAmounts?.forEach(function (marketId) {

                                currentMarketIdsForMatchedAmounts[marketId] = response.subscriptionId;
                            });

                            for (var marketId in currentMarketIdsForMatchedAmounts) {
                                if (currentMarketIdsForMatchedAmounts.hasOwnProperty(marketId)) {
                                    if (matchedAmountDelegates[marketId] === undefined) {

                                        matchedAmounts[marketId] = matchedAmounts[marketId] || managerOptions.gecController.getCachedSubscribedMarketMatchedAmount(marketId);
                                        if (matchedAmounts[marketId] === undefined) {
                                            delete matchedAmounts[marketId];
                                            return;
                                        }
                                        var id = matchedAmounts[marketId].addDelegate(function (matchedAmount, changes) {
                                            controllerOptions.onMatchedAmountChange({ newObject: matchedAmount, changes: changes });
                                        });

                                        matchedAmountDelegates[marketId] = id;
                                    }
                                    controllerOptions.onMatchedAmountChange({ newObject: matchedAmounts[marketId] });
                                }
                            }
                        }
                        params.callbackOnSuccess(response);
                    },
                    callbackOnException: function (resp) {
                        console.error("SubscribeMarketMatchedAmounts Exception:" + resp.name + resp.returnCode);
                        if (params.callbackOnException) {
                            params.callbackOnException(resp);
                        }
                    }
                });
            };

            //only one called from outside
            this.startSubscriptions = function (params) {
                var uuid = createUUID();
                subscribedIds[uuid] = [];

                //setup the initial load handler for each object type and then on first load attached the change delegate handler
                //Events
                if (controllerOptions.onEventChange !== undefined) {
                    managerOptions.gecController.addSubscribedExchangeEventILDelegate(function startEvent(eventClassifier) {

                        var id = eventClassifier.addDelegate(function (changedEventClassifier, changes) {
                            controllerOptions.onEventChange({ newObject: changedEventClassifier, changes: changes });
                        });

                        eventDelegates[eventClassifier.eventClassifierId] = id;

                        eventClassifiers[eventClassifier.eventClassifierId] = eventClassifiers[eventClassifier.eventClassifierId] || eventClassifier;
                        controllerOptions.onEventChange({ newObject: eventClassifier });

                    });
                }


                var batches = [];
                var batchIndex = 0;
                var pushSettings = managerOptions.pushSettings || { batchLimit: 100 };
                var i, j;

                var processNextBatch = function () {
                    var thisBatchIndex = batchIndex;
                    batchIndex = batchIndex + 1;
                    if (batches[thisBatchIndex] !== undefined) {
                        batches[thisBatchIndex].params.callbackOnSuccess = processNextBatch;
                        batches[thisBatchIndex].params.callbackOnException = params.callbackOnException;
                        batches[thisBatchIndex].method(batches[thisBatchIndex].params);

                    } else {

                        //console.log("all done" + batchIndex);
                        params.callbackOnSuccess(subscribedIds);
                    }

                };

                if (params.eventClassifierId !== undefined && params.eventClassifierId > 0) {

                    var newParams = {
                        wantSelectionInformation: params.wantSelectionInformation,
                        eventClassifierId: params.eventClassifierId,
                        uuid: uuid
                    };

                    batches.push({ method: subscribeToMarketInformation, params: newParams });

                }

                if (params.marketIdsForInformation !== undefined && params.marketIdsForInformation.length > 0) {
                    for (i = 0, j = params.marketIdsForInformation.length; i < j; i += pushSettings.batchLimit) {
                        newParams = {
                            wantSelectionInformation: true,
                            marketIdsForInformation: params.marketIdsForInformation.slice(i, i + pushSettings.batchLimit),
                            uuid: uuid
                        };

                        batches.push({ method: subscribeToMarketInformation, params: newParams });
                    }
                }
                if (params.marketIdsForInformationWithoutSelections !== undefined && params.marketIdsForInformationWithoutSelections.length > 0) {
                    for (i = 0, j = params.marketIdsForInformationWithoutSelections.length; i < j; i += pushSettings.batchLimit) {

                        batches.push({
                            method: subscribeToMarketInformation, params: {
                                wantSelectionInformation: false,
                                marketIdsForInformation: params.marketIdsForInformationWithoutSelections.slice(i, i + pushSettings.batchLimit),
                                uuid: uuid
                            }
                        });
                    }
                }
                if (params.marketIdsForMatchedAmounts !== undefined && params.marketIdsForMatchedAmounts.length > 0) {
                    for (i = 0, j = params.marketIdsForMatchedAmounts.length; i < j; i += pushSettings.batchLimit) {

                        batches.push({
                            method: subscribeToMarketMatchedAmount, params: {
                                marketIdsForMatchedAmounts: params.marketIdsForMatchedAmounts.slice(i, i + pushSettings.batchLimit),
                                uuid: uuid
                            }
                        });
                    }
                }
                if (params.marketIdsForPrices !== undefined && params.marketIdsForPrices.length > 0) {
                    for (i = 0, j = params.marketIdsForPrices.length; i < j; i += pushSettings.batchLimit) {

                        batches.push({
                            method: subscribeToMarketPrices, params: {
                                marketIdsForPrices: params.marketIdsForPrices.slice(i, i + pushSettings.batchLimit),
                                uuid: uuid
                            }
                        });
                    }
                }
                if (params.marketIdsForSportsbookPrices !== undefined && params.marketIdsForSportsbookPrices.length > 0) {
                    for (i = 0, j = params.marketIdsForSportsbookPrices.length; i < j; i += pushSettings.batchLimit) {

                        batches.push({
                            method: subscribeToMarketSportsbookPrices, params: {
                                marketIdsForSportsbookPrices: params.marketIdsForSportsbookPrices.slice(i, i + pushSettings.batchLimit),
                                uuid: uuid
                            }
                        });
                    }
                }

                processNextBatch();

            };

            //called after a connection reconnect or when the punter priceForamt/marketBy Volume changed
            this.restartMarketSubscription = function (params) {

                var instance = this;

                // eslint-disable-next-line no-sequences, no-unused-expressions
                marketDelegates = {};
                matchedAmountDelegates = {};
                selectionDelegates = {};
                priceDelegates = {};
                eventDelegates = {};
                sportsbookPriceDelegates = {};

                var marketIdsForInformationWithSelections = [];
                var marketIdsForInformationWithoutSelections = [];
                var marketIdsForMatchedAmounts = [];
                var marketIdsForPrices = [];
                var marketIdsForSportsbookPrices = [];

                for (var marketId in currentMarketIdsForInformationWithSelections) {
                    if (currentMarketIdsForInformationWithSelections.hasOwnProperty(marketId)) {
                        marketIdsForInformationWithSelections.push(marketId);
                    }
                }
                for (marketId in currentMarketIdsForInformationWithoutSelections) {
                    if (currentMarketIdsForInformationWithoutSelections.hasOwnProperty(marketId)) {
                        marketIdsForInformationWithoutSelections.push(marketId);
                    }
                }
                for (marketId in currentMarketIdsForMatchedAmounts) {
                    if (currentMarketIdsForMatchedAmounts.hasOwnProperty(marketId)) {
                        marketIdsForMatchedAmounts.push(marketId);
                    }
                }
                for (marketId in currentMarketIdsForPrices) {
                    if (currentMarketIdsForPrices.hasOwnProperty(marketId)) {
                        marketIdsForPrices.push(marketId);
                    }
                }
                for (marketId in currentMarketIdsForSportsbookPrices) {
                    if (currentMarketIdsForSportsbookPrices.hasOwnProperty(marketId)) {
                        marketIdsForSportsbookPrices.push(marketId);
                    }
                }


                if (marketIdsForInformationWithSelections.length === 0) {
                    marketIdsForInformationWithSelections = undefined;
                }
                if (marketIdsForInformationWithoutSelections.length === 0) {
                    marketIdsForInformationWithoutSelections = undefined;
                }
                if (marketIdsForMatchedAmounts.length === 0) {
                    marketIdsForMatchedAmounts = undefined;
                }
                if (marketIdsForPrices.length === 0) {
                    marketIdsForPrices = undefined;
                }
                if (marketIdsForSportsbookPrices.length === 0) {
                    marketIdsForSportsbookPrices = undefined;
                }

                var tempParams = {
                    groupId: params.groupId,
                    marketIdsForInformation: marketIdsForInformationWithSelections,
                    marketIdsForInformationWithoutSelections: marketIdsForInformationWithoutSelections,
                    marketIdsForMatchedAmounts: marketIdsForMatchedAmounts,
                    marketIdsForPrices: marketIdsForPrices,
                    marketIdsForSportsbookPrices: marketIdsForSportsbookPrices,
                    callbackOnSuccess: function () { }
                };

                this.startSubscriptions(tempParams);

                //loop through invidual markets and resubscribe to these individually
                for (marketId in currentIndividualMarkets) {
                    if (currentIndividualMarkets.hasOwnProperty(marketId)) {
                        instance.addMarketSubscription({
                            marketId: marketId,
                            wantSelectionInformation: true,
                            numberForSidePrices: 3,
                            numberAgainstSidePrices: 3,
                            callbackOnSuccess: function () {

                            },
                            callbackOnException: function (response) {
                                console.error("Error resubscribing to individual market:" + response.returnCode);
                                if (params.callbackOnException) {
                                    params.callbackOnException(response);
                                }
                            }
                        });
                    }
                }

            };


            //allows caller to subscribe to one market at a time
            this.addMarketSubscription = function (params) {

                var marketIdsForPrices = params.marketIds || [params.marketId];

                //strip out undefined marketIds
                marketIdsForPrices = marketIdsForPrices.filter(function (el) {
                    return el !== undefined;
                });

                var marketCount = 0;

                function doMarket(marketId) {
                    currentMarketIdsForInformation[marketId] = true;
                    managerOptions.gecController.subscribeMarketInformation({
                        marketIds: [marketId],
                        eventClassifierId: undefined,
                        fetchOnly: false,
                        wantExchangeLangugeInformationOnly: true,
                        wantSelectionInformation: (params.wantSelectionInformation === true),
                        wantSelectionBlurb: (params.wantSelectionBlurb !== false),
                        marketTaggedValueTopicNames: "XSP~XSPA",
                        callbackOnSuccess: function (response) {

                            currentSubscriptionsIds.push(response.subscriptionId);
                            currentMarketIdsForInformation[marketId] = response.subscriptionId;

                            currentIndividualMarkets[marketId] = currentIndividualMarkets[marketId] || {};
                            currentIndividualMarkets[marketId][response.subscriptionId] = true;

                            if (params.wantSportsbookPrices) {
                                managerOptions.gecController.subscribeFixedOddsMarketPrices({
                                    marketIds: [marketId],
                                    eventClassifierId: undefined,
                                    fetchOnly: false,
                                    callbackOnSuccess: function (fixedOddsResponse) {
                                        currentSubscriptionsIds.push(fixedOddsResponse.subscriptionId);
                                        currentIndividualMarkets[marketId][fixedOddsResponse.subscriptionId] = true;
                                        marketCount = marketCount + 1;

                                        if (marketIdsForPrices[marketCount] === undefined) {
                                            params.callbackOnSuccess();
                                        } else {
                                            doMarket(marketIdsForPrices[marketCount]);
                                        }

                                        //loop through the selections and fire price change
                                        if (controllerOptions.onSportsbookPriceChange !== undefined) {
                                            for (var selectionId in selections) {
                                                if (selections.hasOwnProperty(selectionId)) {
                                                    var selection = selections[selectionId];
                                                    if (selection.marketId === marketId) {
                                                        controllerOptions.onSportsbookPriceChange({ newObject: sportsbookPrices[selectionId] });
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    callbackOnException: function (exceptionResponse) {
                                        console.error("Exception:subscribeDetailedMarketPrices " + marketId + " returnCode:" + exceptionResponse.returnCode);
                                        if (params.callbackOnException) {
                                            params.callbackOnException(exceptionResponse);
                                        }
                                    }
                                });

                            } else {
                                managerOptions.gecController.subscribeDetailedMarketPrices({
                                    numberBackPrices: params.numberForSidePrices || 3,
                                    numberLayPrices: params.numberAgainstSidePrices || 3,
                                    filterByVolume: managerOptions.preferences.marketByVolumeAmount || 1,
                                    marketIds: [marketId],
                                    eventClassifierId: null,
                                    fetchOnly: false,
                                    callbackOnSuccess: function (exchangePricesResponse) {
                                        currentSubscriptionsIds.push(exchangePricesResponse.subscriptionId);
                                        currentIndividualMarkets[marketId][exchangePricesResponse.subscriptionId] = true;
                                        marketCount = marketCount + 1;

                                        if (marketIdsForPrices[marketCount] === undefined) {
                                            params.callbackOnSuccess();
                                        } else {
                                            doMarket(marketIdsForPrices[marketCount]);
                                        }

                                        //loop through the selections and fire price change
                                        if (controllerOptions.onPriceChange !== undefined) {
                                            for (var selectionId in selections) {
                                                if (selections.hasOwnProperty(selectionId)) {
                                                    var selection = selections[selectionId];
                                                    if (selection.marketId === marketId) {
                                                        controllerOptions.onPriceChange({ newObject: prices[selection.selectionId] });
                                                    }
                                                }

                                            }

                                        }

                                    },
                                    callbackOnException: function (exceptionResponse) {
                                        console.error("Exception:subscribeDetailedMarketPrices " + marketId + " returnCode:" + exceptionResponse.returnCode);
                                        if (params.callbackOnException) {
                                            params.callbackOnException(exceptionResponse);
                                        }
                                    }
                                });
                            }

                            if (controllerOptions.onMarketChange !== undefined) {
                                if (markets[marketId]) {
                                    controllerOptions.onMarketChange({
                                        newObject: markets[marketId]
                                    });
                                }
                            }
                        },
                        callbackOnException: function (response) {
                            console.error("Exception:subscribeMarketInformation " + marketId + " returnCode:" + response.returnCode);
                            if (params.callbackOnException) {
                                params.callbackOnException(response);
                            }
                        }
                    });

                }
                if (marketIdsForPrices[marketCount] === undefined) {
                    params.callbackOnSuccess();
                } else {
                    doMarket(marketIdsForPrices[marketCount]);
                }


            };

            //allows caller to unsubscribe to one market at a time
            this.removeMarketSubscription = function (params) {
                var subscriptionIds = [];

                for (var s in currentIndividualMarkets[params.marketId]) {
                    if (currentIndividualMarkets[params.marketId].hasOwnProperty(s)) {
                        subscriptionIds.push(s);
                    }
                }

                params.marketIds?.forEach(function (marketId) {
                    for (var s2 in currentIndividualMarkets[marketId]) {
                        if (currentIndividualMarkets[marketId].hasOwnProperty(s2)) {
                            subscriptionIds.push(s2);
                        }
                    }

                });


                if (subscriptionIds.length === 0) {
                    params.callbackOnSuccess();
                    return;
                }

                managerOptions.gecController.unsubscribe({
                    subscriptionIds: subscriptionIds,
                    callbackOnSuccess: function () {
                        delete currentIndividualMarkets[params.marketId];

                        params.marketIds?.forEach(function (marketId) {
                            delete currentIndividualMarkets[marketId];
                        });

                        params.callbackOnSuccess();
                    },
                    callbackOnException: function (resp) {
                        if (params.callbackOnException) {
                            params.callbackOnException(resp);
                        }

                    }
                });

            };

            var unloadUITimeout;

            //unubscribe everthing for this controller
            this.unloadUI = function (params) {
                subscribedIds = {};
                var instance = this;
                function doAfterUnsubscribe() {
                    if (controllerOptions.clearPricesFromUI !== undefined) {
                        controllerOptions.clearPricesFromUI.call();
                    }
                }

                var anotherCallInProgress = gettingPrices;

                if (anotherCallInProgress) {
                    console.log("sm:unloadUI-anotherCallInProgress");
                    if (unloadUITimeout) {
                        window.clearTimeout(unloadUITimeout);
                    }
                    unloadUITimeout = window.setTimeout(function () {
                        instance.unloadUI(params);
                    }, 1);

                    return;
                }

                //make sure we dont call unsubscribe without ids as everything will be unsubscribed
                if (currentSubscriptionsIds.length === 0) {
                    doAfterUnsubscribe();
                    params.callbackOnSuccess();
                    return;
                }

                //console.log("sm:unloadUI-unsubscribe");
                managerOptions.gecController.unsubscribe({
                    subscriptionIds: currentSubscriptionsIds,
                    callbackOnSuccess: function () {

                        if (gettingPrices) {
                            instance.unloadUI(params);
                            return;

                        }

                        for (var eventClassifierId in eventDelegates) {
                            if (eventDelegates.hasOwnProperty(eventClassifierId)) {
                                if (eventClassifiers[eventClassifierId] === undefined) {
                                    console.warn("tried to remove delegate from eventClassifier that doesnt exist" + eventClassifierId);
                                    return;
                                }
                                eventClassifiers[eventClassifierId].removeDelegate(eventDelegates[eventClassifierId]);
                                delete eventDelegates[eventClassifierId];

                                //if no other component subscribed delete from subscritionManager
                                if (eventClassifiers[eventClassifierId].prototype.getDelegateCount() === 0) {
                                    delete eventClassifiers[eventClassifierId];
                                }
                            }

                        }

                        //loop through all markets as may hav received ones we don't explicity want
                        for (eventClassifierId in eventClassifiers) {
                            if (eventClassifiers.hasOwnProperty(eventClassifierId)) {
                                //if no other component subscribed delete from subscritionManager
                                if (eventClassifiers[eventClassifierId].prototype.getDelegateCount() === 0) {
                                    delete markets[eventClassifierId];
                                }
                            }

                        }

                        for (var marketId in marketDelegates) {
                            if (marketDelegates.hasOwnProperty(marketId)) {
                                if (markets[marketId] === undefined) {
                                    console.warn("tried to remove delegate from market that doesnt exist" + marketId);
                                    return;
                                }
                                markets[marketId].removeDelegate(marketDelegates[marketId]);
                                delete marketDelegates[marketId];

                                //if no other component subscribed delete from subscritionManager
                                if (markets[marketId].prototype.getDelegateCount() === 0) {
                                    delete markets[marketId];
                                }
                            }

                        }

                        //loop through all markets as may hav received ones we don't explicity want
                        for (marketId in markets) {
                            //if no other component subscribed delete from subscritionManager
                            if (markets[marketId].prototype.getDelegateCount() === 0) {
                                delete markets[marketId];
                            }

                        }
                        for (var i in selectionDelegates) {
                            if (selectionDelegates.hasOwnProperty(i)) {
                                if (selections[i] === undefined) {
                                    console.warn("tried to remove delegate from selection that doesnt exist" + i);
                                    return;
                                }
                                selections[i].removeDelegate(selectionDelegates[i]);
                                delete selectionDelegates[i];

                                //if no other component subscribed delete from subscritionManager
                                if (selections[i].prototype.getDelegateCount() === 0) {
                                    delete selections[i];
                                }
                            }

                        }
                        for (i in selections) {
                            //if no other component subscribed delete from subscritionManager
                            if (selections[i].prototype.getDelegateCount() === 0) {
                                delete selections[i];
                            }

                        }
                        for (i in matchedAmountDelegates) {
                            if (matchedAmountDelegates.hasOwnProperty(i)) {
                                if (matchedAmounts[i] === undefined) {
                                    console.warn("tried to remove delegate from matchedAmount that doesnt exist" + i);
                                    return;
                                }
                                matchedAmounts[i].removeDelegate(matchedAmountDelegates[i]);
                                delete matchedAmountDelegates[i];

                                //if noe other component subscribed delete from subscritionManager
                                if (matchedAmounts[i].prototype.getDelegateCount() === 0) {
                                    delete matchedAmounts[i];
                                }
                            }

                        }
                        for (i in priceDelegates) {
                            if (priceDelegates.hasOwnProperty(i)) {
                                if (prices[i] === undefined) {
                                    console.warn("tried to remove delegate from price that doesnt exist" + i);
                                    return;
                                }

                                prices[i].removeDelegate(priceDelegates[i]);
                                delete priceDelegates[i];

                                //if noe other component subscribed delete from subscritionManager
                                if (prices[i].prototype.getDelegateCount() === 0) {
                                    delete prices[i];
                                }
                            }

                        }
                        //loop through all prices as may hav received ones we don't explicity want
                        for (i in prices) {

                            //if no other component subscribed delete from subscritionManager
                            if (prices[i].prototype.getDelegateCount() === 0) {
                                delete prices[i];
                            }

                        }

                        for (i in sportsbookPriceDelegates) {
                            if (sportsbookPriceDelegates.hasOwnProperty(i)) {
                                if (sportsbookPrices[i] === undefined) {
                                    console.warn("tried to remove delegate from sportsbookPrice that doesnt exist" + i);
                                    return;
                                }

                                //if noe other component subscribed delete from subscritionManager
                                if (sportsbookPrices[i].prototype.getDelegateCount() === 0) {
                                    delete sportsbookPriceDelegates[i];
                                    delete sportsbookPrices[i];
                                }
                            }

                        }


                        currentMarketIdsForInformation = {};
                        currentMarketIdsForInformationWithSelections = {};
                        currentMarketIdsForInformationWithoutSelections = {};
                        currentMarketIdsForPrices = {};
                        currentMarketIdsForSportsbookPrices = {};
                        currentMarketIdsForMatchedAmounts = {};
                        currentSelectionIdsForPrices = {};

                        managerOptions.gecController.cleanUp();

                        currentSubscriptionsIds = [];
                        doAfterUnsubscribe();
                        params.callbackOnSuccess();


                    },
                    callbackOnException: function (resp) {
                        console.error("Exception unsubscribe:" + resp.name + resp.returnCode);
                        //kl still problem after login no default priceFormat alert('unsubscribe exception:' + ex.returnCode);

                        if (params.callbackOnException) {
                            params.callbackOnException(resp);
                        }

                    }
                });


            };

            this.getPrice = function (selId) {
                return prices[selId] || { backPrices: [], layPrices: [] };
            };

            this.getSportsbookPrice = function (selId) {
                return sportsbookPrices[selId] || { "selectionId": selId, "price": "" };
            };

            this.getState = function () {
                return {
                    marketIdsForInformation: currentMarketIdsForInformation,
                    marketIdsForPrices: currentMarketIdsForPrices,
                    marketIdsForMatchedAmounts: currentMarketIdsForMatchedAmounts,
                    selectionIdsForPrices: currentSelectionIdsForPrices,
                    individualMarkets: currentIndividualMarkets
                };
            };

        };// end of Controller

        function indexSelection(selection) {

            indexedMarketSelections[selection.marketId] = indexedMarketSelections[selection.marketId] || [];

            //loop through market array to see if already there.
            var currentIndex;
            indexedMarketSelections[selection.marketId].forEach(function (existingSelection, index) {
                if (existingSelection.selectionId === selection.selectionId) {
                    currentIndex = index;
                }

            });

            if (currentIndex === undefined) {
                indexedMarketSelections[selection.marketId].push(selection);
            } else {
                indexedMarketSelections[selection.marketId][currentIndex] = selection;
            }

            indexedMarketSelections[selection.marketId].sort(function (a, b) {
                return a.displayOrder < b.displayOrder ? -1 : 1;
            });

        }
        this.getMarketSelections = function (marketId) {
            return indexedMarketSelections[marketId];
        };

        this.getPrice = function (selId) {
            return prices[selId] || { backPrices: [], layPrices: [] };
        };

        this.getSportsbookPrice = function (selId) {
            return sportsbookPrices[selId];
        };
        this.getSelection = function (selId) {
            return selections[selId];
        };
        this.getMarket = function (marketId) {
            return markets[marketId];
        };


        var getState = function () {
            return {
                markets: markets,
                matchedAmounts: matchedAmounts,
                eventClassifiers: eventClassifiers,
                prices: prices,
                selections: selections
            };
        };
        this.getState = getState;

    }; // end of subscriptionManager
}

export default SubscriptionManagerV3AAPI;